<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>


    <iframe  frameborder="3" height="900" src="https://www.conocer.gob.mx/contenido/seccionesExtras/reconocer/paginas/guia_conocer.php#" width="100%"></iframe>



